import React, { useEffect, useRef, useState } from "react";
import ProfileDropdown from "../ProfileDropdown/ProfileDropdown";
import { DropDownArrowIconSvg, ExternalIconSvg } from "../../assets/svg";
import { usePrivateContext } from "../../context/private.context";
interface TopbarProps {}

const Topbar: React.FC<TopbarProps> = () => {
  const { auth: { authData } } = usePrivateContext();

  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const notificationsRef: any = useRef(null);
  const profileRef: any = useRef(null);

  useEffect(() => {
    const handleDocumentClick = (event: any) => {
      if (
        notificationsRef.current &&
        !notificationsRef.current.contains(event.target) &&
        showNotifications
      ) {
        setShowNotifications(false);
      }
      if (
        profileRef.current &&
        !profileRef.current.contains(event.target) &&
        showProfile
      ) {
        setShowProfile(false);
      }
    };

    document.body.addEventListener("click", handleDocumentClick);

    return () => {
      document.body.removeEventListener("click", handleDocumentClick);
    };
  }, [showNotifications, showProfile]);
  const handleCordeliaClick = () => {
    window.open(
      "https://docs.google.com/spreadsheets/d/1NZEqKmZ75V1oOM6KgL_MTSIU3-yqU9ryF6DuLVeuHrg/edit#gid=1258633082",
      "_blank"
    );
  };
  return (
    <div className="flex items-center flex-wrap-none justify-center z-40 h-20 border-bottom">
      <div className="px-4 py-3 flex-1 flex justify-between items-center max-w-[2000px]">
        <div>
          <button
            className="custom-btn primary-btn flex justify-center items-center	gap-1"
            onClick={handleCordeliaClick}
          >
            Cordelia 365  <ExternalIconSvg fill="#ffff"/>
          </button>
        </div>
        <div className="flex items-center gap-x-6 relative ">
          <div
            className="cursor-pointer flex items-center gap-3 border rounded-md px-3 py-2 mr-4 bg-[#fff]"
            onClick={(event) => {
              event.stopPropagation();
              setShowProfile(!showProfile);
            }}
          >
            <div className="h-[40px] w-[40px] bg-[#D0566E] flex items-center justify-center rounded-full ">
              <span className="text-uppercase tracking-wider font-bold text-lg text-[#fff]">
                {authData?.firstName?.[0] + authData?.lastName?.[0] || ">_<"}
              </span>
            </div>
            <span className={`mt-1 ${showProfile ? "rotate-180" : ""}`}>
              <DropDownArrowIconSvg />
            </span>
          </div>
          {showProfile && (
            <div
              ref={profileRef}
              className={`absolute inset-y-0 bg-white h-fit max-h-[400px] shadow-lg gap-y-3 z-50 block top-16 right-0 rounded-xl`}
            >
              <ProfileDropdown />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Topbar;
